import {toast} from 'react-toastify'
function SuccessMesages(msg){
    toast.info(msg,{
        position: toast.POSITION.TOP_CENTER,
        autoClose:true,
        progressStyle:{"transform-origin": "right"} });

}
export default SuccessMesages;